export default {"src":"/_next/static/media/plane_40.f01b9c08.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};